import type { BoardDetails, BoardObjectInfo, HistoryItem, SnapshotItem } from './model/boardModel'
import Net from '@/services/net'

export function createBoard(boardId: string, data: any) {
  return Net.whiteboard.post<{ boardId: string }>(`/boards`, { id: boardId, data })
}

export function getBoardObjectInfo(boardId: string, objectId: string) {
  return Net.whiteboard.get<BoardObjectInfo[]>(`/boards/${boardId}/objects/${objectId}/info`)
}

export function getBoardDetails(boardId: string) {
  return Net.whiteboard.get<BoardDetails>(`/boards/${boardId}`)
}

export function getBoardHistory(boardId: string) {
  return Net.whiteboard.get<HistoryItem[]>(`/boards/${boardId}/history`)
}

export function getBoardSnapshots(boardId: string) {
  return Net.whiteboard.get<SnapshotItem[]>(`/boards/${boardId}/snapshots`)
}

export function getBoardSnapshot(boardId: string, version: number) {
  return Net.whiteboard.get(`/boards/${boardId}/snapshots/${version}`)
}
